import { OnInit } from '@angular/core';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
export class CloseEventsComponent extends UnsubscribeOnDestroyAdapter {
    constructor(service, datePipe, data) {
        super();
        this.service = service;
        this.datePipe = datePipe;
        this.data = data;
        this.dailyTask = [];
    }
    ngOnInit() {
        switch (this.data.type_event) {
            case 'daily':
                this.getDailyTasks(this.datePipe.transform(Date.now(), 'MM/dd/yyyy'));
                break;
            case 'close':
                this.dailyTask = [
                    Object.assign({}, this.data.body)
                ];
                break;
        }
    }
    getDailyTasks(date) {
        const parseDate = new Date(date);
        const monthDate = String(parseDate.getMonth() + 1).padStart(2, '0');
        const yearDate = parseDate.getFullYear();
        const dayDate = String(parseDate.getDate()).padStart(2, '0');
        this.subs.add(this.service
            .get('task/calendar/detail/list/' +
            yearDate +
            '-' +
            monthDate +
            '-' +
            dayDate, {})
            .subscribe((tasks) => {
            this.dailyTask = tasks;
        }));
    }
}
